import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { SeFeFormService } from 'se-fe-form-service'
import { UserServiceResources as us } from 'se-resource-types'

/**
 * @deprecated This component has been deprecated and removed from the
 * household setup flow for the time being.
 * @todo Revisit this and remove or reimplement.
 */
@Component({
  selector: 'se-po-add-child-contact-info',
  templateUrl: './add-child-contact-info.component.html',
  styleUrls: ['./add-child-contact-info.component.scss'],
})
export class AddChildContactInfoComponent implements OnInit {
  @Input() public persona: us.Persona
  @Input() public description: string

  public ready = false
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService
  ) { }

  public get value(): any {
    return this.form.value.contactInfo
  }

  public isValid(): boolean {
    return this.formService.isValid(this.form)
  }


  public ngOnInit(): void {
    this.createForm()
    this.ready = true
  }

  public reset(): void {
    this.ready = false
    setTimeout(() => {
      this.form.reset()
      this.ready = true
    })
  }

  private createForm(): void {
    this.form = this.fb.group({
      contactInfo: [{ email: '', phone: '' }]
    })
  }
}
